import React from 'react';
import './ArrowIndicator.css';

const ArrowIndicator = () => {
  return (
    <div className="arrow-indicator">
      <div className="arrow-chevron">
        <svg width="48" height="24" viewBox="0 0 48 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 4L24 20L44 4" stroke="var(--color-primary-yellow)" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
      <div className="arrow-chevron">
        <svg width="48" height="24" viewBox="0 0 48 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 4L24 20L44 4" stroke="var(--color-primary-yellow)" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
    </div>
  );
};

export default ArrowIndicator;